import { render, staticRenderFns } from "./recoverRetrieveList.vue?vue&type=template&id=5d1c517b&scoped=true"
import script from "./recoverRetrieveList.vue?vue&type=script&lang=js"
export * from "./recoverRetrieveList.vue?vue&type=script&lang=js"
import style0 from "./recoverRetrieveList.vue?vue&type=style&index=0&id=5d1c517b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1c517b",
  null
  
)

export default component.exports